import {
  PUT_REDUX_CONTACT_LIST,
} from '../../reducers/constants';

const putReduxAllContacts = (contactsList) => ({
  type: PUT_REDUX_CONTACT_LIST,
  contactsList,
});
export default putReduxAllContacts;
